// extracted by mini-css-extract-plugin
export default {"containerClassName":"src-layout-EditorPageLayout-EditorCollapsePageLayout-SectionHOC-css-module__containerClassName--Ql2nj"};